import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { CommonModule, DatePipe } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { InventoryPurchaseOrderHeaderAddressDto } from "../../../core/models/inventoryPurchases/InventoryPurchaseHeaderLineDto";
import { OwnerList } from "../../../core/models/inventoryPurchases/ownerListDto";
import { UpdateInventoryPurchaseOrderHeaderDto } from "../../../core/models/inventoryPurchases/UpdatePurchaseOrderDto";
import { GetBacForSalesOrderDto } from "../../../core/models/orders/getBacForSalesOrderDto";
import { StockPhrase } from "../../../core/models/orders/stockPhrase";
import { Address } from "../../../core/models/shared/address";
import { City } from "../../../core/models/shared/cityList";
import { AddressCounty } from "../../../core/models/shared/countyList";
import { Currency } from "../../../core/models/shared/currencyList";
import { District } from "../../../core/models/shared/districtList";
import { ExchangeRatesDto } from "../../../core/models/shared/exchangeRateDto";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { AddressState } from "../../../core/models/shared/stateList";
import { UsersList } from "../../../core/models/users/users/usersList";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { GetAllVendorsDto } from "../../../core/models/vendor/getAllVendors";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { SamplepoSummaryService } from "../../../core/services/samplepo-summary.service";
import { StockPhrasesComponent } from "../../../shared/components/stock-phrases/stock-phrases.component";
import { ClientPurpose } from "../../../shared/enums/clientPurpose";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { SamplepoShipToAddressComponent } from "../../samplePo/components/samplepo-ship-to-address/samplepo-ship-to-address.component";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../core/services/user-management.service";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import buildQuery from "odata-query";
import { TableModule } from "primeng/table";
import { DatePickerModule } from "primeng/datepicker";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { InventoryPurchaseSummaryListingComponent } from "../inventory-purchase-summary-listing/inventory-purchase-summary-listing.component";
import { InventoryPurchaseLinesComponent } from "../inventory-purchase-lines/inventory-purchase-lines.component";
import { ChildPoConfirmationComponent } from "../child-po-confirmation/child-po-confirmation.component";
import { InventoryPurchaseShipToAddressComponent } from "../inventory-purchase-ship-to-address/inventory-purchase-ship-to-address.component";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { Popover, PopoverModule } from "primeng/popover";
import { GetVendorSearchResponseDto } from "../../../core/models/vendor/getVendorSearchResponseDto";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { SamplePOForm } from "../../../core/models/inventoryPurchases/inventoryPurchaseForm.dto";
import { AddSamplePOHeaderWithLineDto } from "../../../core/models/samplePO/details/addSamplePoDto";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";
import { ItemsSecurity } from "../../../core/models/samplePO/details/itemsSecurity";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { computeMinDate } from "../../../core/utilities/mindate-function";

@UntilDestroy()
@Component({
  selector: "jni-inventory-purchase-summary",
  templateUrl: "./inventory-purchase-summary.component.html",
  styleUrls: ["./inventory-purchase-summary.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    DatePickerModule,
    SelectModule,
    ModalStackerComponent,
    InventoryPurchaseSummaryListingComponent,
    InventoryPurchaseLinesComponent,
    ChildPoConfirmationComponent,
    InventoryPurchaseShipToAddressComponent,
    PopoverModule,
    CheckboxModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
    FormsModule,
  ],
})
export class InventoryPurchaseSummaryComponent implements OnInit, OnChanges {
  shipDateCurrentdate!: Date;
  inHandDateCurrentdate!: Date;
  shipDate = new Date().toISOString();
  inHandDate = new Date().toISOString();
  shipDateOne = "";
  inHandDateOne = "";
  //vendorVerification: any[] = [];
  legalName = "";
  shipToAddress = false;
  vendorAccountAndBook = false;
  firmOneCheckBox = false;
  bcUserDefaultSelectionId = 0;
  bcList: UsersList[] = [];
  bacList: GetBacForSalesOrderDto[] = [];
  samplePOForm: FormGroup;
  showSmallLoader = false;
  countryRegionSelectedId = "";
  countryRegionList: AddressCountryRegion[] = [];
  //getFilteredZipCode: any[] = [];
  //getZipCode: any[] = [];
  cityList: City[] = [];
  stateSelectedId = "";
  stateList: AddressState[] = [];
  districtList: District[] = [];
  countyList: AddressCounty[] = [];
  addressValidationStatus = true;
  customerBillToObject?: ClientSearchList;
  shiftToAddressList!: Address[];
  //vendorAccountSearchList: any;
  vendorAccountSeletion = "";
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  currencyList: Currency[] = [];
  addressBookName = "";
  vendorAccountNumber = "";
  brandingConsultantObject!: GetBCForSalesOrderDto;
  currencyObject?: ExchangeRatesDto;
  currencyConversion?: ExchangeRatesDto;
  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  showAddress = false;
  displayPosition = false;
  displayPositionDescription = false;
  displayPositionFactory = false;
  position = "bottom-right";
  closable = false;
  displayModal = false;
  importUserRights = true;
  customerCheckbox = true;
  vendorCheckbox = true;
  customerId = "";
  userRoleId = 0;
  inventoryPurchaseLineItemsModal = false;
  samplePOSummaryDisplayModal = false;
  vendorList: GetAllVendorsDto[] = [];
  vendorDetails!: GetVendorSearchResponseDto[];
  clientLists: ClientSearchList[] = [];
  addressBookList: Address[] = [];
  shiftToAddressField = "";
  releasedProductsList: ReleasedProduct[] = [];
  shippingProductsList: ShippingMethod[] = [];
  stockListing: StockPhrase[] = [];
  filerStockListing: StockPhrase[] = [];
  selectedAccountNumber = "";
  isAddressValidationButton = true;
  netValueWithIcon = "";
  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";
  userPersonnelNumber!: string;
  vendorDisplayModal = false;

  public searchVendor$ = new Subject<string>();
  public searchClient$ = new Subject<string>();
  creatSamplePoObject!: AddSamplePOHeaderWithLineDto;
  lines!: PurchaseOrderLine[];

  printPdfModal = false;
  openPrinfPdfFlag = false;
  purchaseOrderLine: string[] = [];

  sitewarehouseMapper: Record<string, string> = {
    CA: "DG",
    DG: "CA",
    JNI: "JNI",
  };

  storesField = [
    {
      id: 1,
      name: "REDHAT",
      clientAccNumber: "81004914",
      clientPartyNumber: "PTY000019712",
    },
    {
      id: 2,
      name: "BOOZALLEN",
      clientAccNumber: "81015306",
      clientPartyNumber: "PTY000037130",
    },
  ];

  filteredStoresField = [
    {
      id: 1,
      name: "REDHAT",
      clientAccNumber: "81004914",
      clientPartyNumber: "PTY000019712",
    },
    {
      id: 2,
      name: "BOOZALLEN",
      clientAccNumber: "81015306",
      clientPartyNumber: "PTY000037130",
    },
  ];

  userRole = 0;
  enumUserRole = UserRole;

  productSecurity = {} as ItemsSecurity;

  @Input() samplePOIdFromModal = "";
  @Input() isFromStacker = false;

  @Output() cancelButtonEvent = new EventEmitter();

  @Input() isEditable = false;

  @ViewChild("stockPhraseDescription", { static: false })
  stockPhraseDescription!: StockPhrasesComponent;

  @ViewChild("stockPhraseFactory", { static: false })
  stockPhraseFactory!: StockPhrasesComponent;

  @ViewChild("samplepoaddress", { static: false })
  samplepoaddress!: SamplepoShipToAddressComponent;

  //@ViewChild('clientdt') table: any;
  isDisabled = true;
  deliveryAddress = [
    {
      id: 3,
      name: "Vendor",
      status: false,
    },
    {
      id: 5,
      name: "One Time",
      status: false,
    },
    {
      id: 6,
      name: "One Time Blank",
      status: false,
    },
  ];

  owner_list: OwnerList[] = [
    {
      name: "DG",
      value: "RH-JNICore",
      description: "Red Hat - JNI Core",
      store: "REDHAT",
    },
    {
      name: "DG",
      value: "RH-Global",
      description: "RED HAT - GLOBAL STORE",
      store: "REDHAT",
    },
    {
      name: "DG",
      value: "BOOZALLEN",
      description: "BOO960",
      store: "BOOZALLEN",
    },
  ];
  filtered_owner_list: OwnerList[] = [];
  warehouseField = [
    {
      id: 1,
      name: "DG",
    },
    {
      id: 2,
      name: "JNI",
    },
  ];

  vendorAccNumber = "";
  addressField = {
    deliveryAddressfield: "deliveryAddressDescription",
    countryRegionfield: "countryRegionIdD365",
    addressFormatField: "addressFormat",
    addressLine2Field: "addressLine2",
    addressLine3Field: "addressLine3",
    cityD365Field: "cityD365",
    stateD365Field: "stateD365",
    zipCodeD365Field: "zipCodeD365",
    streetD365Field: "streetD365",
    attentionInformationD365Field: "attention",
    locationD365Field: "locationD365",
    addressD365Field: "addressD365",
    isPrimaryD365Field: "isPrimaryD365",
    validateAddressField: "validateAddress",
    shipToEmail: "shipToEmail",
  };
  samplePOSummary = {} as InventoryPurchaseOrderHeaderAddressDto;
  samplePONumber = "";
  samplePOModalStatus = false;
  siteField = [
    {
      id: 1,
      name: "JNI",
    },
    {
      id: 2,
      name: "CA",
    },
  ];

  constructor(
    private _router: ActivatedRoute,
    private _samplepoListingService: SamplepoListingService,
    private _inventoryPurchaseSummaryService: InventoryPurchaseService,
    private _addNewClientService: AddNewClientService,
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private route: Router,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    public datepipe: DatePipe,
    private _samplePOSummaryService: SamplepoSummaryService
  ) {
    this._router.params.subscribe(params => {
      this.samplePONumber = params["samplePONumber"];
      this.samplePOIdFromModal = params["samplePONumber"];
    });
    this.samplePOForm = this._formBuilder.group({
      header: this._formBuilder.group({
        orderVendorAccountNumberD365: ["", [Validators.required]],
        vendorAccountNumber: [""],
        jobNameD365: ["", [Validators.minLength(2), Validators.maxLength(150)]],
        gpPercentage: [{ value: "", disabled: true }],
        customerRef365: [""],
        siteD365: [""],
        warehouseD365: ["", [Validators.required]],
        storeD365: ["", [Validators.required]],
        expectedStoreAvailableSalesDateD365: [""],
        expectedStoreReceiptDateD365: ["", [Validators.required]],
        firm: [false],
        clientProspectNumber: [""],
        brandingConsultantIdD365: ["", [Validators.required]],
        accountCoordinatorD365: [""],
        bAC: [""],
        vendorName: [""],
        vendorAddress: [""],
        vendorPhone: [""],
        vendorEmail: [""],
        deliveryModeIdD365: [""],
        accountNumber: [""],
        ownerD365: [""],
        currencyCodeD365: [{ value: "", disabled: true }],
        shipToDeliveryAddressList: [""],
        isnetInForeignCurrencyStatus: [{ value: false, disabled: true }],
        invPurchases: [true],
        invPurchaseCompleted: [false],
      }),
      addressInformation: this._formBuilder.group({
        attention: [""],
        locationD365: [""],
        deliveryAddressDescription: ["", Validators.required],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [{ value: "", disabled: true }],
        cityD365: [{ value: "", disabled: true }],
        stateD365: [{ value: "", disabled: true }],
        addressD365: [""],
        streetD365: [""],
        purposeD365: ClientPurpose.Business,
        isPrimaryD365: "1",
        shipToEmail: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        addressLocationNumberD365: [0],
        validateAddress: [""],
        addressFormat: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: [""],
        createdDate: [""],
        createdBy: [""],
      }),
    });
    // this.inHandDateCurrentdate.setDate(
    //   this.inHandDateCurrentdate.getDate() + 1
    // );
  }

  formErrors: Record<string, string> = {
    vendorAccountNumber: "",
    orderVendorAccountNumberD365: "",
    brandingConsultantIdD365: "",
    orderedPurchaseQuantityD365: "",
    externalItemNumberD365: "",
    itemNumberD365: "",
    jobNameD365: "",
    deliveryAddressDescription: "",
    countryRegionIdD365: "",
    deliveryNameD365: "",
    shipToEmail: "",
    storeD365: "",
    expectedStoreReceiptDateD365: "",
    warehouseD365: "",
    ownerD365: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    vendorAccountNumber: {
      required: "3PL is required.",
    },
    storeD365: {
      required: "Store is required.",
    },
    ownerD365: {
      required: "Owner is required.",
    },
    warehouseD365: {
      required: "Warehouse is required.",
    },
    expectedStoreReceiptDateD365: {
      required: "In-hands date is required.",
    },
    jobNameD365: {
      minlength: "Job name must contain 2 characters.",
      maxlength: "Job name must contain 150 characters.",
      required: "Job name is required.",
    },
    orderVendorAccountNumberD365: {
      required: "3PL is required.",
    },
    brandingConsultantIdD365: {
      required: "Branding consultant is required.",
    },
    orderedPurchaseQuantityD365: {
      required: "Quantity is required.",
    },
    externalItemNumberD365: {
      required: "Vendor sku is required.",
    },
    itemNumberD365: {
      required: "Category is required.",
    },
    deliveryAddressDescription: {
      required: "Delivery address is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
  };

  ngOnInit(): void {
    this.samplePOForm.disable();
    this.getInventoryPurchaseSummary(this.samplePONumber);
    this.getInventoryPOLines(this.samplePONumber);
    this.getUserProfile();
    this.getCurrencyListData();
    this.disabledVendorsFields();
    // this.disabledCountryAndStreetFields();
    this.getCountryRegionListData();
    this.getAllShippingMethod();
    this.getAllReleaseProduct();
    this.disabledInitialFields();
    // this.getAllBcUsers();
    this.getAllChildPo();
    this.searchClientName();
    this.getWhoISupport();
    this.supportRoles();
    this.samplePOForm.valueChanges.subscribe(data => {
      this.addressValidation(data);
    });
  }

  editFields() {
    if (!this.isDisabled) {
      this.samplePOForm.disable();
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
      this.samplePOForm.enable();
      this.samplePOForm.get(["header", "vendorName"])?.disable();
      this.samplePOForm.get(["header", "vendorAddress"])?.disable();
      this.samplePOForm.get(["header", "vendorPhone"])?.disable();
      this.samplePOForm.get(["header", "vendorEmail"])?.disable();
      this.samplePOForm.get(["header", "siteD365"])?.disable();
      this.samplePOForm.get(["header", "warehouseD365"])?.disable();

      this.samplePOForm
        .get(["header", "orderVendorAccountNumberD365"])
        ?.disable();
    }
  }

  ngOnChanges() {
    if (this.samplePOIdFromModal) {
      this.samplePONumber = this.samplePOIdFromModal;
      this.samplePOModalStatus = true;
    }
  }

  disabledInitialFields() {
    this.samplePOForm.get(["lines", "lineAmountD365"])?.disable();
    this.samplePOForm.get(["header", "currencyCodeD365"])?.disable();
    //this.samplePOForm.get(['lines', 'purchasePriceD365'])?.disable();
    this.samplePOForm.get(["lines", "netConversion"])?.disable();
    this.samplePOForm.get(["lines", "netConversionTotal"])?.disable();
  }

  onVendorModal() {
    const vendorAccount = this.samplePOForm.get([
      "header",
      "orderVendorAccountNumberD365",
    ])?.value;
    if (vendorAccount) {
      this.vendorDisplayModal = true;
    }
  }

  openPrinfPdfModal() {
    if (this.purchaseOrderLine.length === 1) {
      this.onPreview(this.purchaseOrderLine[0]);
    } else {
      this.printPdfModal = true;
    }
  }

  closePrinfPdfModal() {
    this.printPdfModal = false;
  }

  onPreview(purchaseNumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(purchaseNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message);
            return;
          }
          const blob = this.b64toBlob(res.data, "application/pdf");
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Load PDF");
        },
      });
  }

  getAllChildPo() {
    this._inventoryPurchaseSummaryService
      .getAllChildPo(this.samplePONumber)
      .subscribe({
        next: res => {
          this.purchaseOrderLine = res.data;
          if (this.purchaseOrderLine.length > 0) {
            this.openPrinfPdfFlag = true;
          } else {
            this.openPrinfPdfFlag = false;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  copyInventoryPurchase() {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .copyInventoryPurchase(this.samplePONumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (
            res.status.toLowerCase() == "success" &&
            res.data?.PurchaseOrderId
          ) {
            this._toastr.success("Success", res.message);
            this.samplePONumber = res.data.PurchaseOrderId;
            this.route.navigate([
              `inventory-purchase/inventory-purchase-lines/${res.data.PurchaseOrderId}`,
            ]);

            return;
          }

          this._toastr.success(
            "Error",
            res.message || `Error while Copying the order`
          );
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Create Copy of the order");
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  closeModal() {
    this.vendorDisplayModal = false;
  }

  change() {
    this.samplePOForm.disable();
  }

  revert() {
    this.samplePOForm.enable();
  }

  onCurrencyEnable(event: CheckboxChangeEvent) {
    if (event?.checked) {
      this.samplePOForm.get(["header", "currencyCodeD365"])?.enable();
      this.samplePOForm.get(["lines", "purchasePriceD365"])?.disable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.showForeignCurrency = true;
    } else {
      this.samplePOForm.get(["header", "currencyCodeD365"])?.disable();
      this.samplePOForm.get(["lines", "purchasePriceD365"])?.enable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.currencyConversion = undefined;
      this.showForeignCurrency = false;
    }
  }

  closeModalFromSamplePOSummary() {
    this.samplePOSummaryDisplayModal = false;
  }

  clearCurrencyCodeRecordAndNetInForeignCurrency() {
    this.samplePOForm.patchValue({
      header: {
        currencyCodeD365: "",
      },
      lines: {
        purchasePriceD365: "",
        lineAmountD365: "",
        netConversion: "",
        netConversionTotal: "",
      },
    });
  }

  logValidationErrors(group: FormGroup = this.samplePOForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  validateAddress() {
    this.showSmallLoader = true;
    const address = "usa ca street 1";
    this._addNewClientService
      .checkAddressValidation(address)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res.data == true) {
            this.samplePOForm
              .get(["addressInformation", "addressD365"])
              ?.clearValidators();
            this.samplePOForm
              .get(["addressInformation", "addressD365"])
              ?.updateValueAndValidity();
            this.addressValidationStatus = false;
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  addressValidation(data: SamplePOForm) {
    const addressObj = data.addressInformation;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
      this.samplePOForm
        .get(["addressInformation", "addressD365"])
        ?.setValidators(Validators.required);
    } else {
      this.isAddressValidationButton = true;
    }
  }

  clearValidationOnAddress() {
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.clearValidators();
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  applyValidationOnAddress() {
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.setValidators(Validators.required);
    this.samplePOForm
      .get(["addressInformation", "addressD365"])
      ?.updateValueAndValidity();
  }

  onCurrencyConversion() {
    this.showSmallLoader = true;
    const currency = this.samplePOForm.get([
      "header",
      "currencyCodeD365",
    ])?.value;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
            if (this.currencyConversion) {
              this.patchValueInRates(this.currencyConversion.Rate.toString());
            }
            this.samplePOForm.get(["lines", "purchasePriceD365"])?.enable();
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  patchValueInRates(rates: string) {
    this.samplePOForm.patchValue({
      lines: {
        rates: parseFloat(rates),
      },
    });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  getAllReleaseProduct() {
    this._samplepoListingService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.releasedProductsList = res.data.filter(
            item => item.poStopped === "No"
          );
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  onBrandingConsultantSelection(
    drop: Popover,
    event: MouseEvent,
    target: HTMLElement
  ) {
    drop.show(event, target);
  }

  getAllBcUsers() {
    this._samplepoListingService
      .getAllBrandingConsultant()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            if (this.brandingConsultantLists) {
              if (this.brandingConsultantLists.length > 0) {
                this.brandingConsultantObject = this.brandingConsultantLists[0];
                this.patchValueInBrandingConsultant(
                  this.brandingConsultantLists[0].personnelNumber
                );
                this.getBACList(res.data[0].id);
              }
            }
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInBrandingConsultant(data: string) {
    this.samplePOForm.patchValue({
      header: {
        brandingConsultantIdD365: data,
      },
    });
  }

  onSelectionChange(event: SelectChangeEvent, type: string) {
    if (type === "warehouse") {
      this.samplePOForm.patchValue({
        header: {
          siteD365: this.sitewarehouseMapper[`${event.value}`],
        },
      });
    } else {
      this.samplePOForm.patchValue({
        header: {
          warehouseD365: this.sitewarehouseMapper[`${event.value}`],
        },
      });
    }
    this.samplePOForm.patchValue({
      header: {
        ownerD365: "",
      },
    });
    this.filtered_owner_list = this.owner_list.filter(
      item =>
        item.name === this.samplePOForm.get(["header", "warehouseD365"])?.value
    );
  }

  onProjectIdSelection(event: GetBCForSalesOrderDto, dropdown: Popover) {
    this.brandingConsultantObject = event;
    this.getBacForSalesOrder(event.personnelNumber);
    this.patchProjectIdInBCField(event);
    dropdown.hide();
    const deliveryAddress = this.samplePOForm.get([
      "addressInformation",
      "deliveryAddressDescription",
    ])?.value;
    if (deliveryAddress === "Branding Consultant") {
      this.clearAllShifToForm();
      this.samplepoaddress?.clearAllShifToForm();
      this.brandingConsultantObject = event;
      this.samplepoaddress?.patchBrandingConsultantName();
    }
  }

  patchProjectIdInBCField(event: GetBCForSalesOrderDto) {
    this.samplePOForm.patchValue({
      header: {
        brandingConsultantIdD365: event.personnelNumber,
      },
    });
  }

  // onVendorAddressBookSelect(event: any) {
  //   if (this.addressBookList?.length > 1) {
  //     event.open();
  //   } else {
  //     event.close();
  //   }
  // }

  supportRoles() {
    this._samplepoListingService
      .supportRoles()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.productSecurity = res.data;
          this.filterStores();
        },
      });
  }

  filterStores() {
    if (this.userRole !== this.enumUserRole.Admin) {
      this.filteredStoresField = [];
      if (this.productSecurity && Object.keys(this.productSecurity).length) {
        if (this.productSecurity.redHat) {
          this.filteredStoresField = this.storesField.filter(
            x => x.name == "REDHAT"
          );
        }

        if (this.productSecurity.boozAllen) {
          const boozProducts = this.storesField.filter(
            x => x.name == "BOOZALLEN"
          );
          this.filteredStoresField.push(...boozProducts);
        }
      }
    }
  }

  onVendorRowSelection(
    vendorSelectedRow: GetAllVendorsDto,
    vendorToggle: Popover
  ) {
    this.showSmallLoader = true;
    this.clearVendorForm();
    const partyNumber = vendorSelectedRow.partyNumber;
    const accountNumber = vendorSelectedRow.vendorAccountNumber;
    const currency = vendorSelectedRow.currency;
    this._samplepoListingService
      .getVendorAddressByPartyNumber(partyNumber, accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          const primaryAddress = res.data.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" ||
              x.isPrimaryD365?.toLowerCase() === "1"
          );
          if (primaryAddress.length > 0) {
            if (primaryAddress[0].addressD365) {
              this.patchValuesInVendorFormAddressField(
                primaryAddress[0].addressD365
              );
            }
          }
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
    this.patchValuesInVendorForm(vendorSelectedRow);
    this.patchAccountNumber(accountNumber ?? "");
    this.patchVendorCurrency(currency);
    vendorToggle.hide();
  }

  patchAccountNumber(acountNumber: string) {
    this.vendorAccountNumber = acountNumber;
    this.vendorCheckbox = false;

    this.samplePOForm.patchValue({
      header: {
        orderVendorAccountNumberD365: acountNumber,
      },
    });
  }

  patchVendorCurrency(currency: string) {
    this.samplePOForm.patchValue({
      header: {
        currencyCodeD365: currency,
      },
    });
  }

  // onClientSelection(event: any, clientProspetToggle: any) {
  //   const name = event.organizationNameD365;
  //   this.selectedAccountNumber = event.clientAccount;
  //   this.customerBillToObject = event;
  //   this.samplePOForm.patchValue({
  //     header: {
  //       clientProspectNumber: name,
  //       deliveryModeIdD365: event.shippingMethod,
  //       accountNumber: event.salesAccountNumberD365
  //     }
  //   });
  //   this.onShippingMethodSelect(event.shippingMethod);
  //   if (event.name != '') {
  //     this.deliveryAddress[0].status = false;
  //     this.deliveryAddress[1].status = false;
  //   } else {
  //     this.deliveryAddress[0].status = true;
  //     this.deliveryAddress[1].status = true;
  //   }
  //   if (this.selectedAccountNumber) {
  //     this.customerId = this.selectedAccountNumber;
  //     if (this.customerId) {
  //       this.customerCheckbox = false;
  //     }
  //   }
  //   // this.getBCForSalesOrder(
  //   //   event.clientAccount);

  //   const deliveryAddress = this.samplePOForm.get([
  //     'addressInformation',
  //     'deliveryAddressDescription'
  //   ])?.value;
  //   if (
  //     deliveryAddress === 'Bill To' ||
  //     deliveryAddress === 'Customer Address Book' ||
  //     deliveryAddress === 'Branding Consultant'
  //   ) {
  //     this.clearAllShifToForm();
  //     this.samplepoaddress?.clearAllShifToForm();
  //   }

  //   clientProspetToggle.close();
  // }

  getBCForSalesOrder(accountNumber: string) {
    this.selectedAccountNumber = accountNumber.toString() || "";
    this._samplepoListingService
      .getBCForSalesOrder(accountNumber ?? "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            if (this.brandingConsultantLists.length > 0) {
              this.brandingConsultantObject = this.brandingConsultantLists[0];
              this.patchValueInBrandingConsultant(
                this.brandingConsultantLists[0].personnelNumber
              );
            } else {
              this.patchValueInBrandingConsultant("");
            }
            this.getBacForSalesOrder(
              this.brandingConsultantObject?.personnelNumber
            );
          }
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string, defaultSelection = "") {
    this._samplepoListingService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            if (defaultSelection === "") {
              defaultSelection =
                this.bacList.find(x => x.isPrimary)?.personnelNumber ??
                this.bacList[0]?.personnelNumber ??
                "";
            }
            this.patchValueInBacField(defaultSelection);
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.samplePOForm.patchValue({
      header: {
        accountCoordinatorD365: personnelNumber,
      },
    });
  }

  clearVendorForm() {
    this.samplePOForm.patchValue({
      header: {
        vendorName: "",
        vendorPhone: "",
        vendorEmail: "",
        vendorAddress: "",
      },
    });
  }

  patchClientAccountNumber(accountNumber: string) {
    this.samplePOForm.patchValue({
      header: {
        accountNumber: accountNumber,
      },
    });
  }

  clearClientAccountNumber() {
    this.samplePOForm.patchValue({
      header: {
        accountNumber: [""],
      },
    });
  }

  // onclientSelection(event: any, client: any) {
  //   const clientname = event.target.value;
  //   if (clientname == '') {
  //     this.deliveryAddress[0].status = true;
  //     this.deliveryAddress[1].status = true;
  //     this.clearClientAccountNumber();
  //   }
  //   if (clientname != '' && clientname != undefined) {
  //     client.open();
  //     this._samplepoListingService
  //       .getClientAndProspectByNameAndAccountNumberFilter(clientname)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.data != null) {
  //             this.clientLists = res.data;
  //           }
  //           this.showSmallLoader = false;
  //         },
  //         error: () => {
  //           this.showSmallLoader = false;
  //         }
  //       });
  //   }
  // }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  patchValuesInVendorFormAddressField(address: string) {
    this.samplePOForm.patchValue({
      header: {
        vendorAddress: address,
      },
    });
  }

  patchValuesInVendorForm(vendorSelectedRow: GetAllVendorsDto) {
    this.samplePOForm.patchValue({
      header: {
        vendorName: vendorSelectedRow.vendorName,
        vendorPhone: vendorSelectedRow.phoneNumber,
        vendorEmail: vendorSelectedRow.emailAddress,
      },
    });
  }

  searchVendorName(vendorAccNumber: string) {
    this._samplepoListingService
      .getVendorByNameAndAccountNumberFilter(vendorAccNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          const responseAccNumber = res.data[0].vendorAccountNumber;
          const responsePartyNumber = res.data[0].partyNumber;
          this.vendorDetails = res.data;
          this._samplepoListingService
            .getVendorAddressByPartyNumber(
              responsePartyNumber ?? "",
              responseAccNumber
            )
            .subscribe({
              next: resp => {
                this._loaderService.setLoaderState(false);
                this.vendorDetails = [
                  ...this.vendorDetails,
                  ...(resp.data as unknown as GetVendorSearchResponseDto[]),
                ];
                this.initializeVendorInfo(this.vendorDetails[0]);
              },
              error: () => {
                this._loaderService.setLoaderState(false);
              },
            });
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  initializeVendorInfo(vendorDetails: GetVendorSearchResponseDto) {
    this.samplePOForm.patchValue({
      header: {
        vendorName: vendorDetails.vendorName,
        vendorAddress: vendorDetails.addressD365,
        vendorPhone: vendorDetails.phoneNumber,
        vendorEmail: vendorDetails.emailAddress,
      },
    });
  }

  onVendorSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    target: HTMLElement
  ) {
    mydrop.show(event, target);
  }

  searchClientName() {
    this.searchClient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }
          const clientname = searchitem;
          if (clientname == "") {
            this.deliveryAddress[0].status = true;
            this.deliveryAddress[1].status = true;
            this.clearClientAccountNumber();
            const deliveryAddress = this.samplePOForm.get([
              "addressInformation",
              "deliveryAddressDescription",
            ])?.value;

            if (
              deliveryAddress === "Bill To" ||
              deliveryAddress === "Customer Address Book"
            ) {
              this.clearAllShifToForm();
              this.samplepoaddress?.clearAllShifToForm();
            }
          } else {
            return this._samplepoListingService.getClientAndProspectByNameAndAccountNumberFilter(
              clientname
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.clientLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // onClientSearchOpenToggle(mydrop: any) {
  //   mydrop.open();
  // }

  disabledAddressFields() {
    this.samplePOForm.get(["addressInformation", "zipCodeD365"])?.disable();
    this.samplePOForm.get(["addressInformation", "streetD365"])?.disable();
  }

  disabledVendorsFields() {
    this.samplePOForm.get(["header", "vendorName"])?.disable();
    this.samplePOForm.get(["header", "vendorAddress"])?.disable();
    this.samplePOForm.get(["header", "vendorPhone"])?.disable();
    this.samplePOForm.get(["header", "vendorEmail"])?.disable();
  }

  // onDeliveryAddressChange(event: any, shipaddress: any) {
  //   if (event === 'Bill To') {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfCustomerBillTo();
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === 'Customer Address Book') {
  //     this.shipToAddress = true;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfCustomerAddressBook(shipaddress);
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === 'Vendor') {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = true;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else if (event === 'Branding Consultant') {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = false;
  //     this.showValidateAddress = false;
  //     this.patchAddressOfBrandingConsultant();
  //     this.clearValidationOnAddress();
  //     this.hiddenAddressFields();
  //     this.clearShifToForm();
  //   } else {
  //     this.shipToAddress = false;
  //     this.vendorAccountAndBook = false;
  //     this.showAddressValidation = true;
  //     this.showValidateAddress = true;
  //     this.applyValidationOnAddress();
  //     if (event !== 'One Time') {
  //       this.clearShifToForm();
  //     }
  //     if (event === 'One Time') {
  //       this.clearValidationOnAddress();
  //     }
  //   }
  //   this.enableCountryField(event);
  // }

  // hiddenAddressFields() {
  //   this.showDistrict = false;
  //   this.showPostBox = false;
  //   this.showCity = false;
  //   this.showCounty = false;
  //   this.showState = false;
  //   this.showStreetNumber = false;
  //   this.showbuildingComplement = false;
  //   this.showAddressBook = false;
  //   this.showAppartment = false;
  // }

  clearShifToForm() {
    this.samplePOForm.patchValue({
      addressInformation: {
        // countryRegionIdD365: '',
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  clearAllShifToForm() {
    this.samplePOForm.patchValue({
      addressInformation: {
        deliveryAddressDescription: "",
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        shipToEmail: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  patchAddressOfCustomerBillTo() {
    this.showSmallLoader = true;
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              const primaryAddress = res.data.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" ||
                  x.isPrimaryD365?.toLowerCase() === "1"
              );
              if (primaryAddress.length > 0) {
                this.patchFormInShipToAddressField(primaryAddress[0]);
              }
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  // patchAddressOfCustomerAddressBook(shipaddress: any) {
  //   this.showSmallLoader = true;
  //   if (
  //     this.customerBillToObject?.partyNumber != undefined ||
  //     this.customerBillToObject?.clientAccount != undefined
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(
  //         this.customerBillToObject?.partyNumber,
  //         this.customerBillToObject?.clientAccount
  //       )
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res) => {
  //           this.showSmallLoader = false;
  //           if (res.data != null) {
  //             this.shiftToAddressList = res.data;
  //             shipaddress.open();
  //           }
  //         },
  //         error: () => {
  //           this.showSmallLoader = false;
  //         }
  //       });
  //   }
  // }

  onOwnerDropDownChange(event: SelectChangeEvent) {
    if (event) {
      this.filtered_owner_list = this.owner_list.filter(
        item => item.store == event.value
      );
      const storeData = this.storesField.find(
        item => item.name === event.value
      );
      this.samplePOForm.patchValue({
        header: {
          ownerD365: this.filtered_owner_list[0]?.store,
          warehouseD365: "DG",
          siteD365: "CA",
          clientProspectNumber: storeData?.clientAccNumber,
        },
      });
      if (storeData) {
        this.getBCForSalesOrder(storeData.clientAccNumber);
      }
    } else {
      this.samplePOForm.patchValue({
        header: {
          ownerD365: "",
          warehouseD365: "",
          siteD365: "",
          clientProspectNumber: "",
          brandingConsultantIdD365: "",
          accountCoordinatorD365: "",
        },
      });
      this.filtered_owner_list = [];
    }
  }

  patchAddressOfBrandingConsultant() {
    this.showSmallLoader = true;
    const partyNumber = this.brandingConsultantObject?.partyNumber;
    if (partyNumber != undefined) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(partyNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.patchFormInShipToAddressField(res.data[0]);
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
    this.showSmallLoader = false;
  }

  // onShitToAddressSeletion(event: any, shipAddressToggle: any) {
  //   shipAddressToggle.close();

  //   if (event.addressD365 != '') {
  //     this.shiftToAddressField = event.addressD365;
  //   }
  //   this.patchFormInShipToAddressField(event);
  // }

  patchFormInShipToAddressField(address: Address) {
    if (address) {
      this.samplePOForm.patchValue({
        addressInformation: {
          countryRegionIdD365: address.countryRegionIdD365,
          zipCodeD365: address.zipCodeD365,
          streetD365: address.streetD365,
          cityD365: address.cityD365,
          stateD365: address.stateD365,
          countyD365: address.countyD365,
          streetNumberD365: address.streetNumberD365,
          buildingComplimentD365: address.buildingComplimentD365,
          apartment_RUD365: address.apartment_RUD365,
          postBoxD365: address.postBoxD365,
          districtNameD365: address.districtNameD365,
          addressLocationNumber: parseInt(address.locationNumberD365 ?? "0"),
          addressD365: address.addressD365,
        },
      });
    }
  }

  // enableCountryField(event: any) {
  //   if (event === 'One Time' || event === 'One Time Blank') {
  //     this.samplePOForm
  //       .get(['addressInformation', 'countryRegionIdD365'])
  //       ?.enable();
  //     this.samplePOForm.get(['addressInformation', 'streetD365'])?.enable();
  //   } else {
  //     this.samplePOForm
  //       .get(['addressInformation', 'countryRegionIdD365'])
  //       ?.disable();
  //     this.samplePOForm.get(['addressInformation', 'streetD365'])?.disable();
  //   }
  // }

  //disabledCountryAndStreetFields() {
  // this.samplePOForm
  //   .get(['addressInformation', 'countryRegionIdD365'])
  //   ?.disable();
  // this.samplePOForm.get(['addressInformation', 'streetD365'])?.disable();
  //}

  // onshipToAddressFilter(event: any, drop: any) {
  //   drop.open();
  // }

  // vendorAccountFilter(event: any, drop: any) {
  //   const vendorAccountNumber = event.target.value;
  //   if (vendorAccountNumber != undefined && vendorAccountNumber != '') {
  //     drop.open();
  //     this._samplepoListingService
  //       .getVendorByNameAndAccountNumberFilter(event.target.value)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.data != null) {
  //             this.vendorList = res.data;
  //           }
  //         }
  //       });
  //   } else {
  //     drop.close();
  //   }
  // }

  // onVendorAccountSelection(
  //   event: any,
  //   vendorAccount: any,
  //   vendoraddressbook: any
  // ) {
  //   this.clearShifToForm();
  //   this.vendorAccountSeletion = event.vendorName;
  //   const partyNumber = event.partyNumber;
  //   if (
  //     this.vendorAccountSeletion != undefined &&
  //     this.vendorAccountSeletion != ''
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(partyNumber)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res) => {
  //           if (res.data != null) {
  //             this.addressBookList = res.data;
  //             if (this.addressBookList.length === 1) {
  //               this.onVendorAddressBookSelection(
  //                 this.addressBookList[0],
  //                 vendorAccount
  //               );
  //             }
  //             if (this.addressBookList?.length > 1) {
  //               vendoraddressbook.open();
  //             } else {
  //               vendoraddressbook.close();
  //             }
  //           }
  //         }
  //       });
  //   }
  //   vendorAccount.close();
  // }

  onVendorAddressBookSelection(
    event: Address,
    vendorAddressBookToggle: Popover
  ) {
    this.addressBookName = event.addressD365 ?? "";
    this.samplePOForm.patchValue({
      addressInformation: {
        countryRegionIdD365: event.countryRegionIdD365,
        zipCodeD365: event.zipCodeD365,
        streetD365: event.streetD365,
        cityD365: event.cityD365,
        stateD365: event.stateD365,
        countyD365: event.countyD365,
        streetNumberD365: event.streetNumberD365,
        buildingComplimentD365: event.buildingComplimentD365,
        apartment_RUD365: event.apartment_RUD365,
        postBoxD365: event.postBoxD365,
        districtNameD365: event.districtNameD365,
        addressLocationNumber: parseInt(event.locationNumberD365 ?? ""),
        addressD365: event.addressD365,
      },
    });
    vendorAddressBookToggle?.hide();
  }

  onShipDateSelection(event: Date) {
    const shipDate = new Date(event);
    this.shipDate = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    this.shipDateOne = this.shipDate;
    if (this.shipDate) {
      this.inHandDateCurrentdate = new Date(this.shipDate);
    } else {
      this.inHandDateCurrentdate = new Date();
    }
    this.samplePOForm.patchValue({
      header: {
        expectedStoreAvailableSalesDateD365: this.shipDate,
      },
    });
  }

  getConvertedInHandDate(inHandDate: string) {
    if (inHandDate) {
      return new Date(inHandDate);
    } else {
      return new Date();
    }
  }

  onInHandDateSelection(event: Date) {
    const inHandDate = new Date(event);
    this.inHandDate = this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    this.inHandDateOne = this.inHandDate;
    this.samplePOForm.patchValue({
      header: {
        expectedStoreReceiptDateD365: this.inHandDate,
      },
    });
  }

  getBACList(id: number) {
    this._addNewClientService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bacList = res.data as unknown as GetBacForSalesOrderDto[];
        },
      });
  }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    this.getAddressFormats(filteredRegions[0].addressFormatD365);
  }

  getAddressFormats(formatId: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }

  updateValueOnCountrySelection() {
    this.samplePOForm.patchValue({
      addressInformation: {
        zipCodeD365: "",
        districtNameD365: "",
        cityD365: "",
        countyD365: "",
        stateD365: "",
      },
    });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  addAddressInHeader(samplePoDto: SamplePOForm) {
    if (samplePoDto.addressInformation) {
      samplePoDto.header.attentionInformationD365 =
        samplePoDto.addressInformation.attention ?? "";
      samplePoDto.header.locationD365 =
        samplePoDto.addressInformation.locationD365 ?? "";

      samplePoDto.header.deliveryAddressDistrictNameD365 =
        samplePoDto.addressInformation.districtNameD365 ?? "";

      samplePoDto.header.emailD365 =
        samplePoDto.addressInformation.shipToEmail ?? "";

      samplePoDto.header.deliveryAddressDescription =
        samplePoDto.addressInformation.deliveryAddressDescription ?? "";

      if (this.shiftToAddressField != "") {
        samplePoDto.header.shipToDeliveryAddressList = this.shiftToAddressField;
      }

      if (this.addressBookName != "") {
        samplePoDto.header.vendorAddress = this.addressBookName;
      }
    }
  }

  removeUsedVendorFields(samplePoDto: SamplePOForm) {
    delete samplePoDto.header.vendorName;
    delete samplePoDto.header.vendorPhone;
    delete samplePoDto.header.vendorEmail;
  }

  // patchValuesInLinesPrice(samplePoDto: any) {
  //   samplePoDto.lines.lineAmountD365 = this.netTotalPrice;
  //   samplePoDto.lines.netConversion = this.netConvertToUsd;
  //   samplePoDto.lines.netConversionTotal = this.netTotalPriceConverted;
  // }

  onShippingMethodSelect(shippingMethodCode: SelectChangeEvent) {
    const index = this.shippingProductsList.findIndex(
      x => x.modeCodeD365 == shippingMethodCode.value
    );
    if (index > -1) {
      const selectedShippingMethod = this.shippingProductsList[index];
      if (
        selectedShippingMethod.useFreightAccountD365?.toLowerCase() == "yes"
      ) {
        this.samplePOForm.patchValue({
          header: {
            accountNumber: selectedShippingMethod.jniFreightAcctNumD365,
          },
        });
      } else {
        this._addNewClientService
          .getClientFreightAccountNumber(this.selectedAccountNumber)
          .subscribe({
            next: res => {
              if (res.data) {
                this.samplePOForm.patchValue({
                  header: {
                    accountNumber: res.data,
                  },
                });
              }
            },
            error: () => {
              this.samplePOForm.patchValue({
                header: {
                  accountNumber: "",
                },
              });
            },
          });
      }
    }
  }

  submitButtonlogValidationErrors(group: FormGroup = this.samplePOForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  addSamplePoScreen() {
    this.submitButtonlogValidationErrors();
    this._loaderService.setLoaderState(true);
    const samplePoDto = this.samplePOForm.getRawValue();
    // this.addShifDateInLines(samplePoDto);
    //this.addShifDateInHeader(samplePoDto);
    this.removeUsedVendorFields(samplePoDto);
    //this.patchValuesInLinesPrice(samplePoDto);
    const samplePoLine = [] as PurchaseOrderLine[];
    samplePoLine.push(samplePoDto.lines);
    this.addAddressInHeader(samplePoDto);
    samplePoDto.header.clientProspectNumber = this.selectedAccountNumber;
    const shipDateHeader =
      samplePoDto.header.expectedStoreAvailableSalesDateD365;
    const inHandDateHeader = samplePoDto.header.expectedStoreReceiptDateD365;

    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (!samplePoDto.header.expectedStoreAvailableSalesDateD365) {
      samplePoDto.header.expectedStoreAvailableSalesDateD365 = "";
    }

    if (!samplePoDto.header.expectedStoreReceiptDateD365) {
      samplePoDto.header.expectedStoreReceiptDateD365 = "";
    }

    const shipDateLine = samplePoDto.lines.requestedShippingDateD365;
    const inHandDateLine = samplePoDto.lines.requestedDeliveryDateD365;

    if (shipDateLine && inHandDateLine) {
      if (new Date(inHandDateLine) < new Date(shipDateLine)) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date line greater and equal to ship date line"
        );
        return;
      }
    }

    if (!samplePoDto.lines.requestedShippingDateD365) {
      samplePoDto.lines.requestedShippingDateD365 = "";
    }

    if (!samplePoDto.lines.requestedDeliveryDateD365) {
      samplePoDto.lines.requestedDeliveryDateD365 = "";
    }

    if (samplePoDto.header.firm != undefined) {
      if (samplePoDto.header.firm === true) {
        samplePoDto.header.firm = "YES";
      } else {
        samplePoDto.header.firm = "NO";
      }
    }

    if (samplePoDto.lines.firm != undefined) {
      if (samplePoDto.lines.firm === true) {
        samplePoDto.lines.firm = "YES";
      } else {
        samplePoDto.lines.firm = "NO";
      }
    }

    if (samplePoDto.lines.orderedPurchaseQuantityD365 === 0) {
      this._toastr.error("Error", "Quantity must be greater than zero");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (!this.samplePOForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }

    if (samplePoDto.addressInformation?.deliveryNameD365) {
      samplePoDto.header.deliveryNameD365 =
        samplePoDto.addressInformation.deliveryNameD365;
    }
    if (samplePoDto.addressInformation?.shipToEmail) {
      samplePoDto.header.shipToEmail =
        samplePoDto.addressInformation.shipToEmail;
    }

    const purchaseOrderHeaderAddressDto = {
      purchaseOrderHeader: samplePoDto.header,
      address: samplePoDto.addressInformation,
    };

    if (purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryAddressD365 =
        this.getDeliveryAddress(
          purchaseOrderHeaderAddressDto.purchaseOrderHeader
            .deliveryAddressDescription || "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            ""
        );
    }

    this.creatSamplePoObject = {
      purchaseOrderHeaderAddressDto: purchaseOrderHeaderAddressDto,
      purchaseOrderLines: samplePoLine,
    };

    this._samplepoListingService
      .addSamplePoData(this.creatSamplePoObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data != null) {
            this._toastr.success("Success", "Sample PO added successfully");
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding Sample PO"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding Sample PO");
        },
      });
  }

  showAddressComponent() {
    const deliveryAddress = this.samplePOForm.get([
      "addressInformation",
      "deliveryAddressDescription",
    ])?.value as string;
    if (deliveryAddress?.toLowerCase().includes("one")) {
      this.samplePOForm.get(["addressInformation", "addressD365"])?.enable();
      this.showAddress = false;
      return true;
    } else {
      this.samplePOForm.get(["addressInformation", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  getDescription(event: StockPhrase[]) {
    let description = "";
    event.forEach(element => {
      if (element.description) {
        if (description == "") {
          description += element.description;
        } else {
          description += "\n" + element.description;
        }
      }
    });

    this.samplePOForm.patchValue({
      lines: {
        lineDescriptionD365: description,
      },
    });
    this.closePositionDialogDescription();
  }

  getFactory(event: StockPhrase[]) {
    let fact = "";
    event.forEach(element => {
      if (element.notes) {
        if (fact == "") {
          fact += element.notes;
        } else {
          fact += "\n" + element.notes;
        }
      }
    });

    this.samplePOForm.patchValue({
      lines: {
        factoryNotesD365: fact,
      },
    });
    this.closePositionDialogFactory();
  }

  showPositionDialogDescription(position: string) {
    this.position = position;
    this.displayPositionDescription = true;
    this.stockPhraseDescription.flag = "description";
    this.stockPhraseDescription.selectedStock = [];
    this.stockPhraseDescription.getStockPhraseData();
  }

  showPositionDialogFactory(position: string) {
    this.position = position;
    this.displayPositionFactory = true;
    this.stockPhraseFactory.flag = "factory";
    this.stockPhraseFactory.selectedStock = [];
    this.stockPhraseFactory.getStockPhraseData();
  }

  closePositionDialogDescription() {
    this.displayPositionDescription = false;
  }

  closePositionDialogFactory() {
    this.displayPositionFactory = false;
  }

  onCancel() {
    if (this.isFromStacker) {
      this.cancelButtonEvent.emit();
    } else {
      this.route.navigate(["/inventory-purchase/inventory-purchase-listing"]);
    }
  }

  redirectToLinesGroup() {
    if (this.samplePONumber) {
      this.inventoryPurchaseLineItemsModal = true;
      this.samplePOSummaryDisplayModal = true;
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        this.filterStores();
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.userPersonnelNumber = res.data.personnelNumber;
        }
      },
    });
  }

  patchValueInBc() {
    if (this.userPersonnelNumber && this.brandingConsultantLists.length > 0) {
      const filterBacObject = this.brandingConsultantLists?.filter(
        x => x.personnelNumber === this.userPersonnelNumber
      );
      if (filterBacObject?.length > 0) {
        this.brandingConsultantObject = filterBacObject[0];
        this.patchValueInBrandingConsultant(filterBacObject[0].personnelNumber);
        this.getBacForSalesOrder(filterBacObject[0].personnelNumber);
      } else {
        if (this.brandingConsultantLists.length > 0) {
          this.brandingConsultantObject = this.brandingConsultantLists[0];
          this.patchValueInBrandingConsultant(
            this.brandingConsultantLists[0].personnelNumber
          );
          this.getBacForSalesOrder(
            this.brandingConsultantLists[0].personnelNumber
          );
        }
      }
    }
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  getWhoISupport() {
    this._samplepoListingService
      .getAllWhoISupport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  private getInventoryPOLines(samplePONumber: string) {
    this._loaderService.setLoaderState(true);
    this._inventoryPurchaseSummaryService
      .getInventoryPurchaseLines(samplePONumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.lines = res.data;
            this._loaderService.setLoaderState(false);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  private getInventoryPurchaseSummary(samplePONumber: string) {
    this._loaderService.setLoaderState(true);
    this._inventoryPurchaseSummaryService
      .getInventoryPOSummary(samplePONumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          // const odataFilter = `?$filter=ID eq '${samplePONumber}'`;
          // this._orderSummaryService
          //   .GetJNIDeletedRecordsFilter(odataFilter)
          //   .subscribe();
          this.samplePOSummary = res.data;
          if (res.data) {
            this.bindFormControls();
            this.vendorAccNumber =
              this.samplePOForm.value.header.orderVendorAccountNumberD365;
            this.searchVendorName(
              this.samplePOForm.value.header.orderVendorAccountNumberD365
            );

            this.samplePOForm.patchValue({
              header: {
                invPurchaseCompleted:
                  res.data.purchaseOrderHeader?.invPurchasesCompletedD365 ??
                  false,
              },
            });
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  private bindFormControls() {
    if (
      this.samplePOSummary?.purchaseOrderHeader
        ?.expectedStoreAvailableSalesDateD365
    ) {
      const shipDate = new Date(
        this.samplePOSummary?.purchaseOrderHeader
          ?.expectedStoreAvailableSalesDateD365
      );
      this.shipDateOne = this.datepipe.transform(shipDate, "MM/dd/yyyy") ?? "";
    } else {
      this.shipDateOne = "";
    }

    if (
      this.samplePOSummary?.purchaseOrderHeader?.expectedStoreReceiptDateD365
    ) {
      const inHandDate = new Date(
        this.samplePOSummary?.purchaseOrderHeader?.expectedStoreReceiptDateD365
      );
      this.inHandDateOne =
        this.datepipe.transform(inHandDate, "MM/dd/yyyy") ?? "";
    } else {
      this.inHandDateOne = "";
    }
    this.samplePOForm.patchValue({
      header: {
        jobNameD365: this.samplePOSummary?.purchaseOrderHeader?.jobNameD365,
        expectedStoreAvailableSalesDateD365: this.shipDateOne,
        expectedStoreReceiptDateD365: this.inHandDateOne,
        gpPercentage:
          this.samplePOSummary?.purchaseOrderHeader?.gpPercentage != null
            ? this.samplePOSummary.purchaseOrderHeader.gpPercentage.toFixed(2)
            : "0.00",
        clientProspectNumber:
          this.samplePOSummary.purchaseOrderHeader?.clientProspectNumber,
        brandingConsultantIdD365:
          this.samplePOSummary.purchaseOrderHeader?.brandingConsultantIdD365,
        accountCoordinatorD365:
          this.samplePOSummary.purchaseOrderHeader?.accountCoordinatorD365,
        vendorName: this.samplePOSummary.purchaseOrderHeader?.vendor,
        orderVendorAccountNumberD365:
          this.samplePOSummary?.purchaseOrderHeader
            ?.orderVendorAccountNumberD365,
        vendorAddress: this.samplePOSummary?.purchaseOrderHeader?.vendorAddress,
        // Details
        deliveryModeIdD365:
          this.samplePOSummary?.purchaseOrderHeader?.deliveryModeIdD365,
        accountNumber: this.samplePOSummary?.purchaseOrderHeader?.accountNumber,
        currencyCodeD365:
          this.samplePOSummary?.purchaseOrderHeader?.currencyCodeD365,
        customerRef365:
          this.samplePOSummary?.purchaseOrderHeader?.customerRef365,
        siteD365: this.samplePOSummary?.purchaseOrderHeader?.siteD365,
        warehouseD365: this.samplePOSummary?.purchaseOrderHeader?.warehouseD365,
        storeD365: this.samplePOSummary?.purchaseOrderHeader?.storeD365,
        ownerD365: this.samplePOSummary?.purchaseOrderHeader?.ownerD365,
      },
      addressInformation: {
        deliveryAddressDescription:
          this.samplePOSummary?.purchaseOrderHeader?.deliveryAddressDescription,
        attention:
          this.samplePOSummary?.purchaseOrderHeader?.attentionInformationD365,
        locationD365: this.samplePOSummary?.purchaseOrderHeader?.locationD365,
        countryRegionIdD365: this.samplePOSummary?.address?.countryRegionIdD365,
        zipCodeD365: this.samplePOSummary?.address?.zipCodeD365,
        cityD365: this.samplePOSummary?.address?.cityD365,
        stateD365: this.samplePOSummary?.address?.stateD365,
        streetD365: this.samplePOSummary?.address?.streetD365,
        shipToEmail: this.samplePOSummary?.purchaseOrderHeader?.shipToEmail,
        buildingComplimentD365:
          this.samplePOSummary?.address?.buildingComplimentD365,
        postBoxD365: this.samplePOSummary?.address?.postBoxD365,
        countyD365: this.samplePOSummary?.address?.countyD365,
        streetNumberD365: this.samplePOSummary?.address?.streetNumberD365,
        districtNameD365: this.samplePOSummary?.address?.districtNameD365,
        addressD365: this.samplePOSummary?.address?.addressD365,
        deliveryNameD365:
          this.samplePOSummary?.purchaseOrderHeader?.deliveryAddressD365,
      },
    });

    if (this.samplePOSummary.purchaseOrderHeader?.brandingConsultantIdD365) {
      this.getBacForSalesOrder(
        this.samplePOSummary.purchaseOrderHeader?.brandingConsultantIdD365,
        this.samplePOSummary.purchaseOrderHeader?.accountCoordinatorD365 ?? ""
      );
    }

    this.filtered_owner_list = this.owner_list.filter(
      item => item.store == this.samplePOSummary?.purchaseOrderHeader?.storeD365
    );
    this.shipDateCurrentdate = computeMinDate(
      this.samplePOSummary?.purchaseOrderHeader
        ?.expectedStoreAvailableSalesDateD365
    );
    this.inHandDateCurrentdate = computeMinDate(
      this.samplePOSummary?.purchaseOrderHeader
        ?.expectedStoreAvailableSalesDateD365
    );
  }

  insertEditedPO() {
    this.submitButtonlogValidationErrors();
    this._loaderService.setLoaderState(true);
    const addressInformation = this.samplePOForm.getRawValue();
    if (addressInformation.addressInformation) {
      this.addAddressInHeader(addressInformation);
    }

    const shipDateHeader =
      addressInformation.header.expectedStoreAvailableSalesDateD365;
    const inHandDateHeader =
      addressInformation.header.expectedStoreReceiptDateD365;

    if (shipDateHeader && inHandDateHeader) {
      if (new Date(inHandDateHeader) < new Date(shipDateHeader)) {
        this._toastr.error(
          "Error",
          "In-hands date cannot be earlier than Ship date"
        );
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    if (!addressInformation.header.expectedStoreAvailableSalesDateD365) {
      addressInformation.header.expectedStoreAvailableSalesDateD365 = "";
    }

    if (!addressInformation.header.expectedStoreReceiptDateD365) {
      addressInformation.header.expectedStoreReceiptDateD365 = "";
    }

    if (addressInformation.addressInformation?.deliveryNameD365) {
      addressInformation.header.deliveryNameD365 =
        addressInformation.addressInformation?.deliveryNameD365;
    }
    if (addressInformation.addressInformation?.shipToEmail) {
      addressInformation.header.shipToEmail =
        addressInformation.addressInformation?.shipToEmail;
    }

    const purchaseOrderHeaderAddressDto = {
      purchaseOrderHeader: addressInformation.header,
      address: addressInformation.addressInformation,
    };

    if (purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryAddressD365 =
        this.getDeliveryAddress(
          purchaseOrderHeaderAddressDto.purchaseOrderHeader
            .deliveryAddressDescription || "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            "",
          purchaseOrderHeaderAddressDto.purchaseOrderHeader.deliveryNameD365 ||
            ""
        );
    }

    const payload: UpdateInventoryPurchaseOrderHeaderDto = {
      purchaseOrderHeaderAddressDto: purchaseOrderHeaderAddressDto,
    };

    if (payload?.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      payload.purchaseOrderHeaderAddressDto.purchaseOrderHeader.purchaseOrderNumberD365 =
        this.samplePOSummary?.purchaseOrderHeader?.purchaseOrderNumberD365 ??
        "";
    }

    if (!this.samplePOForm.valid) {
      this._loaderService.setLoaderState(false);
      return;
    }
    if (payload.purchaseOrderHeaderAddressDto?.purchaseOrderHeader) {
      payload.purchaseOrderHeaderAddressDto.purchaseOrderHeader.firm =
        payload.purchaseOrderHeaderAddressDto?.purchaseOrderHeader?.firm?.toString() ??
        "false";
    }
    this._inventoryPurchaseSummaryService.updateInventoryPO(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        this.showAddressComponent();
        if (res.status.toLowerCase() != "success") {
          this._toastr.error("Error", res.message);
          return;
        }
        this._toastr.success("Success", res.message);
        this.getInventoryPurchaseSummary(this.samplePONumber);
        this.editFields();
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", res.message || "Failed To Save PO Header");
      },
    });
  }
}
